import { render, staticRenderFns } from "./placeholder-dialog.vue?vue&type=template&id=272e4c06&"
import script from "./placeholder-dialog.vue?vue&type=script&lang=js&"
export * from "./placeholder-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports